/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_LogInputs */

const en_history_log = /** @type {(inputs: History_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log`)
};

const de_history_log = /** @type {(inputs: History_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eintragen`)
};

/**
* | output |
* | --- |
* | "Log" |
*
* @param {History_LogInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const history_log = /** @type {((inputs?: History_LogInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_LogInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_history_log(inputs)
	return en_history_log(inputs)
});